import {
  listSessionRecords,
  loadSessionRecord,
  sessionRecordFromManifest,
  upsertSessionRecord,
  type SessionRecord,
} from "@/lib/storage/session-record-store";
import { listIncompleteUploadManifests } from "@/lib/storage/upload-manifest-store";
import { filterResumableSessionRecords } from "@/lib/upload/load-upload-session-files";

/**
 * Recreate session records for any incomplete upload manifests that lost their
 * record (e.g. storage was partially cleared), so a resumable upload still shows
 * up in the list.
 */
async function backfillSessionRecordsFromManifests() {
  const manifests = await listIncompleteUploadManifests();
  await Promise.all(
    manifests.map(async (manifest) => {
      const existing = await loadSessionRecord(manifest.clientSessionId);
      if (existing) return;
      await upsertSessionRecord(sessionRecordFromManifest(manifest));
    }),
  );
}

/** List the resumable session records, without the manifest backfill. */
export async function listResumableSessions(): Promise<SessionRecord[]> {
  const records = await listSessionRecords();
  return filterResumableSessionRecords(records);
}

/**
 * Initial registry load: backfill records from manifests first, then list the
 * resumable sessions. Used by the sessions route loader and the home registry
 * hook so both resolve the list the same way.
 */
export async function loadSessionRegistry(): Promise<SessionRecord[]> {
  await backfillSessionRecordsFromManifests();
  return listResumableSessions();
}
